import { getData, postData } from "@/utils/http";
export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: []
	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading;
		},
		CHANGE_ADD_LOADING(state, tableLoading) {
			state.addLoading = tableLoading;
		},
		CHANGE_TABLE_DATA(state, list) {
			state.tableList = list;
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item;
		},
		CHANGE_SEARCH_COLL(state,changeData){
			if(changeData["changeKey"]=="orgId"&&typeof changeData["data"]!="object"){
				state[changeData["changeKey"]] = [changeData["data"]];
			}else{
				state[changeData["changeKey"]] = changeData["data"];
			}
		},
	},
	actions: {
		//获取列表
		getList({ commit, state }) {
			return new Promise((resolve) => {
				getData("platform/sys/dict/list?page=1&size=9999").then((res) => {
					if (res.state == 1) {
						commit("CHANGE_TABLE_DATA", res.data.rows);
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},

		//添加
		addValue({ commit }, addData) {
			return new Promise((resolve) => {
				postData(`platform/sys/dict/value/save`, addData).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},

		
        removeValue({commit},id){
            return new Promise((resolve)=>{
                getData(`platform/sys/dict/delete/value?id=${id}`).then((res)=>{
                    if(res.state==1){
                        resolve({
                            state:1,
                            msg:"操作成功"
                        });
                    }else{
                        resolve({
                            state:0,
                            msg:res.msg
                        });
                    }
                })
            })
        },

		getValue({ commit, state }) {
			return new Promise((resolve) => {
				getData(`platform/sys/dict/value/list?type=${state.activeItem.id}&page=1&size=99999`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data.rows,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						});
					}
				})
			})
		},

		//获取已经启用的字典值
		getAllowValue({ commit, state },type){
			return new Promise((resolve) => {
				getData(`platform/sys/dict/data/type/${type}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
                            msg: "操作成功",
                            data:res.data
						});
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						});
					}
				})
			})
		},


		//写入当前操作t条目
		setActiveItem({ commit }, item) {
			commit("CHANGE_ACTIVE_ITEM", item)
		},


		//写入查询条件
		setSearchData({commit},changeData){
			commit("CHANGE_SEARCH_COLL",changeData)
		},

		//修改loading
		changeAddLoading({ commit }, value) {
			commit("CHANGE_ADD_LOADING", value);
		},

		changeListLoading({ commit }, value) {
			commit("CHANGE_TABLE_LOADING", value)
		}



	}
}
